var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto lg:max-w-screen-2xl w-full px-4 md:px-6 pt-16 pb-12 lg:pt-24 lg:pb-20"},[_c('h2',{staticClass:"block"},[_vm._v(_vm._s(_vm.title)+" is currently not available")])])}
var staticRenderFns = []

export { render, staticRenderFns }